export default {
      id: "chevron-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }